import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { orpc } from "@/client";
import { notifyError } from "@/lib/error-code";
import { WikiLabels } from "@/lib/labels/wiki";

function useInvalidate() {
	const queryClient = useQueryClient();

	return () => {
		void queryClient.invalidateQueries({ queryKey: orpc.wiki.key() });
	};
}

const onError = notifyError(WikiLabels.error);

export function useWikiList() {
	return useQuery(orpc.wiki.list.queryOptions());
}

export function useWikiPage(slug: string) {
	return useQuery(orpc.wiki.page.queryOptions({ input: { slug } }));
}

export function useWikiRevisions(slug: string) {
	return useQuery(orpc.wiki.revisions.queryOptions({ input: { slug } }));
}

export function useWikiCreate() {
	const invalidate = useInvalidate();

	return useMutation(orpc.wiki.create.mutationOptions({ onSuccess: invalidate }));
}

export function useWikiEdit() {
	const invalidate = useInvalidate();

	return useMutation(orpc.wiki.edit.mutationOptions({ onSuccess: invalidate, onError }));
}
